<template>
	<el-drawer :title="ticketType && ticketType== 1 ? '批量上传票款发票' : '批量上传服务费发票'" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="80%"
		@close="close">
		<div class="drawer-content">
			<el-alert type="warning" :closable="false" class="tip-alert">
				<div slot="title">单次最多上传 50 个文件，支持 PDF、OFD、JPG、JPEG、PNG。系统会先解析发票关键字段，再结合发票号码、抬头、识别号、开票金额和票款发票申请信息匹配。</div>
				<div class="tip-tags">
					<el-tag size="mini" type="info">全部关键字段一致的候选自动进入可提交</el-tag>
					<el-tag size="mini" type="info">多个合格候选时按申请创建时间自动取第一条</el-tag>
					<el-tag size="mini" type="info">无候选、字段不一致、重复发票号码识别失败均不可提交</el-tag>
				</div>
			</el-alert>

			<div class="filter-bar">
				<el-select
					v-model="formData.startUserId"
					filterable
					remote
					placeholder="B类客户 可选"
					:remote-method="searchUser"
					:loading="userLoading"
					size="small"
					clearable
					style="width: 260px;">
					<el-option
						v-for="item in userList"
						:key="item.id"
						:label="`[${$userType.get(item.userType)}]${item.name}`"
						:value="item.id">
					</el-option>
				</el-select>
				<el-input placeholder="演出 可选" size="small" v-model.trim="sActivityIds" v-loading="sActivityLoading" style="width: 260px;" class="ML10">
					<el-button slot="append" icon="el-icon-search" @click="searchActivity()"></el-button>
				</el-input>
				<el-select v-model="formData.sessionId" placeholder="场次 可选" clearable
					:disabled="!currentSessions.length" style="width: 260px;" size="small" class="ML10">
					<el-option v-for="g in currentSessions" :key="g.id"
						:label="g.name" :value="g.id">
						{{g.name}}
					</el-option>
				</el-select>
			</div>

			<el-upload class="upload-demo MT20" drag action="" multiple style="width: 100%" :show-file-list="false"
				:accept="accept" :http-request="uploadAction" :on-error="uploadError"
				:disabled="isUploadDisabled" :limit="50" :on-exceed="uploadExceed">
				<div class="upload-inner">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">拖入或选择票款发票文件</div>
					<div class="upload-tip">示例：50 个 PDF + 1个"发票批量下载情况统计.xlsx"；上传后会先进入解析中状态。</div>
				</div>
			</el-upload>
			<div class="result-wrap MT20" v-if="ocrResults.length > 0 || processingList.length > 0">
				<div class="tab-bar">
					<span :class="['tab-item', { active: activeTab === 'all' }]" @click="activeTab = 'all'">全部 <b>{{ ocrResults.length }}</b></span>
					<span :class="['tab-item', { active: activeTab === 'valid' }]" @click="activeTab = 'valid'">可提交 <b>{{ validCount }}</b></span>
					<span :class="['tab-item', { active: activeTab === 'pending' }]" @click="activeTab = 'pending'">待处理 <b>{{ pendingCount }}</b></span>
					<span :class="['tab-item', { active: activeTab === 'invalid' }]" @click="activeTab = 'invalid'">不可提交 <b>{{ invalidCount }}</b></span>
					<span :class="['tab-item', { active: activeTab === 'ignored' }]" @click="activeTab = 'ignored'">已忽略 <b>{{ ignoredCount }}</b></span>
				</div>
				<el-table :data="filteredResults" size="mini" border v-loading="ocrLoading" class="result-table"
					:row-key="row => row.uuid" :expand-row-keys="expandedRowKeys" @expand-change="handleExpandChange">
					<el-table-column type="expand">
						<template slot-scope="{row}">
							<div v-if="row.status === 'pending' && row.rawData && row.rawData.candidates && row.rawData.candidates.length" class="candidate-panel">
								<div class="candidate-title">选择对应开票申请</div>
								<div class="candidate-table">
									<div class="candidate-thead">
										<span class="col-radio"></span>
										<span class="col-ordersn">订单编号</span>
										<span class="col-type">发票类型</span>
										<span class="col-goods">演出名称</span>
										<span class="col-session">场次</span>
										<span class="col-time">申请时间</span>
										<span class="col-user">B类客户</span>
									</div>
									<div class="candidate-tbody">
										<div v-for="c in row.rawData.candidates" :key="c.id"
											class="candidate-row"
											:class="{active: row.selectedCandidateId === c.id}"
											@click="selectCandidate(row, c.id)">
											<span class="col-radio" @click.stop>
												<el-radio :label="c.id" v-model="row.selectedCandidateId"></el-radio>
											</span>
											<span class="col-ordersn">{{ c.orderSn }}</span>
											<span class="col-type">{{ c.typeDesc }}</span>
											<span class="col-goods" :title="c.goodsName">{{ c.goodsName }}</span>
											<span class="col-session">{{ c.sessionName }}</span>
											<span class="col-time">{{ c.applyTime }}</span>
											<span class="col-user">{{ c.startUserId === -1 ? '秀动平台' : (c.startUserName || '-') }}</span>
										</div>
									</div>
								</div>
								<div class="candidate-actions">
									<el-button size="mini" @click="toggleExpand(row)">收起</el-button>
									<el-button type="success" size="mini" @click="confirmCandidate(row)" :disabled="!row.selectedCandidateId">确认关联</el-button>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="发票文件/号码" min-width="200" show-overflow-tooltip>
						<template slot-scope="{row}">
							<div>{{ row.fileName }}</div>
							<div class="sub-text" v-if="row.invoiceNo">{{ row.invoiceNo }}</div>
							<div class="sub-text color-primary" v-if="row.processing">解析中...</div>
						</template>
					</el-table-column>
					<el-table-column label="匹配申请" min-width="180" show-overflow-tooltip>
						<template slot-scope="{row}">
							<span v-if="!row.processing ">{{ row.matchOrderNo ||  row.rawData && row.rawData.matchStatus != 2 && row.rawData.orderSn || '-' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="开票金额" width="100" align="right">
						<template slot-scope="{row}">
							<span v-if="!row.processing">{{ row.amount != null ? row.amount : '-' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="发票抬头" min-width="140" show-overflow-tooltip>
						<template slot-scope="{row}">
							<span v-if="!row.processing">{{ row.title || '-' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="税号/身份证" min-width="180" show-overflow-tooltip>
						<template slot-scope="{row}">
							<span v-if="!row.processing">{{ row.taxId || '-' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="匹配状态" width="90" align="center">
						<template slot-scope="{row}">
							<el-tag v-if="!row.processing && row.status === 'valid'" type="success" size="mini">可提交</el-tag>
							<el-tag v-else-if="!row.processing && row.status === 'pending'" type="warning" size="mini">待处理</el-tag>
							<el-tag v-else-if="!row.processing && row.status === 'invalid'" type="danger" size="mini">不可提交</el-tag>
							<el-tag v-else-if="!row.processing && row.status === 'ignored'" type="info" size="mini">已忽略</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="原因" min-width="120" show-overflow-tooltip>
						<template slot-scope="{row}">
							<span v-if="!row.processing" :class="{'reason-text': row.status === 'invalid'}">{{ row.reason || '-' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120" align="center">
						<template slot-scope="{row}">
							<el-button v-if="!row.processing && row.status === 'pending'" type="text" size="mini" @click="toggleExpand(row)">{{ isExpanded(row.uuid) ? '收起' : '处理' }}</el-button>
							<el-button v-if="!row.processing && row.status !== 'pending'" type="text" size="mini" @click="showDetail(row)">
								{{ row.status === 'invalid' ? '查看原因' : '详情' }}
							</el-button>
							<el-button v-if="!row.processing && row.status === 'invalid'" type="text" size="mini" @click="ignoreRow(row)">忽略</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取消</el-button>
			<el-button type="success" @click="submitForm()" :loading="btnLoading" :disabled="validCount === 0 || ocrLoading">提交可提交记录</el-button>
		</div>

		<el-dialog :visible.sync="detailVisible" title="发票详情" width="600px" append-to-body>
			<div v-if="currentDetail" class="detail-box">
				<el-descriptions :column="2" border size="small">
					<el-descriptions-item label="文件名称">{{ currentDetail.fileName }}</el-descriptions-item>
					<el-descriptions-item label="发票号码">{{ currentDetail.invoiceNo || '-' }}</el-descriptions-item>
					<el-descriptions-item label="开票金额">{{ currentDetail.amount != null ? currentDetail.amount : '-' }}</el-descriptions-item>
					<el-descriptions-item label="发票抬头">{{ currentDetail.title || '-' }}</el-descriptions-item>
					<el-descriptions-item label="税号/身份证" :span="2">{{ currentDetail.taxId || '-' }}</el-descriptions-item>
					<el-descriptions-item label="匹配申请">{{ currentDetail.matchOrderNo || '-' }}</el-descriptions-item>
					<el-descriptions-item label="匹配状态">
						<el-tag v-if="currentDetail.status === 'valid'" type="success" size="mini">可提交</el-tag>
						<el-tag v-else-if="currentDetail.status === 'pending'" type="warning" size="mini">待处理</el-tag>
						<el-tag v-else-if="currentDetail.status === 'invalid'" type="danger" size="mini">不可提交</el-tag>
						<el-tag v-else type="info" size="mini">已忽略</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="原因" :span="2">{{ currentDetail.reason || '-' }}</el-descriptions-item>
				</el-descriptions>
				<div class="detail-raw MT10" v-if="currentDetail.rawData">
					<div class="raw-title">原始数据：</div>
					<pre>{{ JSON.stringify(currentDetail.rawData, null, 2) }}</pre>
				</div>
			</div>
			<div slot="footer">
				<el-button @click="detailVisible = false">关闭</el-button>
			</div>
		</el-dialog>
	</el-drawer>
</template>

<script>
	import {fetchUser, downloadInvoice} from '@/assets/js/commonApi';

	const defaultFormData = {
		startUserId: null,
		sessionId: null,
		goodsId: null,
	}
	export default {
		data() {
			return {
				drawerShow: false,
				btnLoading: false,
				ocrLoading: false,
				ticketType: '',
				userList: [],
				userLoading: false,
				formData: { ...defaultFormData },
				sActivityIds: '',
				sActivityLoading: false,
				sActivityList: [],
				accept: 'image/png, image/jpeg, image/jpg, application/pdf, .ofd, application/ofd, application/vnd.ofd',
				ocrResults: [],
				processingList: [],
				activeTab: 'all',
				detailVisible: false,
				currentDetail: null,
				expandedRowKeys: [],
			}
		},
		computed: {
			currentSessions() {
				const show = this.sActivityList[0];
				return (show && show.sessions) || [];
			},
			isUploadDisabled() {
				return this.ocrResults.length + this.processingList.length >= 50;
			},
			validCount() {
				return this.ocrResults.filter(r => r.status === 'valid').length;
			},
			pendingCount() {
				return this.ocrResults.filter(r => r.status === 'pending').length;
			},
			invalidCount() {
				return this.ocrResults.filter(r => r.status === 'invalid').length;
			},
			ignoredCount() {
				return this.ocrResults.filter(r => r.status === 'ignored').length;
			},
			filteredResults() {
				if (this.activeTab === 'all') return this.ocrResults;
				return this.ocrResults.filter(r => r.status === this.activeTab);
			}
		},
		watch: {
			sActivityList: {
				immediate: true,
				handler(val) {
					const show = val && val[0];
					this.formData.goodsId = show ? show.id : null;
				}
			}
		},
		methods: {
			close() {
				this.drawerShow = false;
			},
			show(type) {
				this.ticketType = type;
				this.ocrResults = [];
				this.processingList = [];
				this.sActivityList = [];
				this.sActivityIds = '';
				this.userList = [];
				this.formData = { ...defaultFormData };
				this.activeTab = 'all';
				this.drawerShow = true;
			},
			// 搜索B类用户
			async searchUser(query) {
				if (query !== '') {
					this.userLoading = true;
					const res = await fetchUser({
						queryValue: query,
						userType: -1,
					}).finally(() => {
						this.userLoading = false;
					});
					const { state, result } = res.data;
					if (state == 1 && result) {
						this.userList = result;
					}
				}
			},
			// 搜索演出
			async searchActivity() {
				if (!this.sActivityIds) return;
				this.sActivityLoading = true;
				const ids = this.sActivityIds.replace(/，/g, ',').split(',').map(s => parseInt(s.trim())).filter(s => !isNaN(s));
				if (ids.length === 0) {
					this.sActivityLoading = false;
					return;
				}
				const res = await this.$request({
					url: '/activity/activityIdNameList',
					method: 'post',
					data: ids
				}).catch(() => {
					return { data: { state: '0', msg: '请求错误' } };
				}).finally(() => {
					this.sActivityLoading = false;
				});
				const { state, msg, result } = res.data;
				if (state != 1) {
					return this.$message.error(msg || '请求失败');
				}
				if (result && result.length > 0) {
					this.sActivityList = [result[0]];
					this.formData.sessionId = null;
				} else {
					this.$message.error(msg || '没有找到相关演出');
				}
			},
			uploadError() {
				this.$message.error('上传失败');
			},
			uploadExceed(files) {
				this.$message.warning(`单次最多上传50个文件，当前已超出。本次尝试选择 ${files.length} 个文件。`);
			},
			// 选中文件后立即上传并OCR
			async uploadAction(req) {
				const { file } = req;
				const maxSize = 1024 * 1024 * 2;
				const acceptedTypes = [
					'application/pdf',
					'image/png',
					'image/jpeg',
					'image/jpg',
					'image/gif',
					'application/ofd',
				];
				const fileExt = (file.name.split('.').pop() || '').toLowerCase();
				const isOfd = fileExt === 'ofd';
				if (!acceptedTypes.includes(file.type) && !isOfd) {
					this.$message.error(`文件 "${file.name}" 格式不支持`);
					return;
				}
				if (file.size > maxSize) {
					this.$message.error(`文件 "${file.name}" 超过2M`);
					return;
				}
				if (this.ocrResults.find(r => r.fileName === file.name) || this.processingList.find(r => r.fileName === file.name)) {
					this.$message.error(`文件 "${file.name}" 已存在`);
					return;
				}
				const uuid = this.$utils.uuid();
				const row = {
					uuid,
					fileName: file.name,
					fileUri: '',
					invoiceNo: '',
					matchOrderNo: '',
					amount: null,
					title: '',
					taxId: '',
					status: 'invalid',
					reason: '',
					rawData: null,
					processing: true,
					selectedCandidateId: null,
				};
				this.processingList.push(row);
				this.ocrResults.push(row);
				// 异步处理：上传 → OCR
				this.processFile(file, row);
			},
			async processFile(file, row) {
				try {
					// 1. 上传文件
					const uploadRes = await downloadInvoice(file).catch(() => null);
					if (!uploadRes || uploadRes.data.state != 1) {
						row.processing = false;
						row.status = 'invalid';
						row.reason = uploadRes && uploadRes.data.msg ? uploadRes.data.msg : '文件上传失败';
						this.processingList = this.processingList.filter(r => r.uuid !== row.uuid);
						return;
					}
					row.fileUri = uploadRes.data.result.urlFull || uploadRes.data.result.url || '';
					// 2. 调 OCR 识别匹配接口
					const params = {
						fileUri: row.fileUri,
						invoiceType: this.ticketType,
					};
					if (this.formData.startUserId) params.startUserId = this.formData.startUserId;
					if (this.formData.goodsId) params.goodsId = this.formData.goodsId;
					if (this.formData.sessionId) params.sessionId = this.formData.sessionId;

					const ocrRes = await this.$request({
						url: '/invoice/record/ocrAndMatch',
						method: 'post',
						data: params,
					}).catch(() => {
						return { data: { state: '0', msg: '识别请求失败' } };
					});
					const { state, msg, result } = ocrRes.data;
					row.processing = false;
					this.processingList = this.processingList.filter(r => r.uuid !== row.uuid);
					if (state == 1 && result) {
						row.rawData = result;
						row.invoiceNo = result.invoiceNumber || result.invoiceNo || '';
						row.amount = result.amount != null ? result.amount : null;
						row.title = result.purchaserName || result.title || '';
						row.taxId = result.taxNumber || result.taxId || '';
						// matchStatus: 1=可提交, 2=待处理, 3=不可提交
						if (result.matchStatus === 1) {
							row.status = 'valid';
							row.reason = result.matchStatusDesc || '可提交';
							if (result.candidates && result.candidates.length > 0) {
								row.selectedCandidateId = result.candidates[0].id;
							}
						} else if (result.matchStatus === 2) {
							row.status = 'pending';
							const candidateCount = result.candidates ? result.candidates.length : 0;
							row.reason = candidateCount > 0 ? `${result.matchStatusDesc}（${candidateCount}个候选）` : result.matchStatusDesc || '待处理';
						} else {
						row.status = 'invalid';
						row.reason = result.failureReason || result.matchStatusDesc || result.reason || '不可提交';
					}
						// 匹配申请：取第一个候选项的订单号
						// if (result.candidates && result.candidates.length > 0) {
						// 	row.matchOrderNo = result.candidates[0].orderSn || '';
						// 	row.selectedCandidateId = result.candidates[0].id || '';
						// }
					} else {
						row.status = 'invalid';
						row.reason = msg || '识别失败';
					}
				} catch (e) {
					row.processing = false;
					row.status = 'invalid';
					row.reason = '解析异常';
					this.processingList = this.processingList.filter(r => r.uuid !== row.uuid);
				}
			},
			ignoreRow(row) {
				row.status = 'ignored';
			},
			isExpanded(uuid) {
				return this.expandedRowKeys.indexOf(uuid) > -1;
			},
			selectCandidate(row, candidateId) {
				this.$set(row, 'selectedCandidateId', candidateId);
			},
			toggleExpand(row) {
				const idx = this.expandedRowKeys.indexOf(row.uuid);
				if (idx > -1) {
					this.expandedRowKeys.splice(idx, 1);
				} else {
					this.expandedRowKeys.push(row.uuid);
					// 默认选中第一个候选项
					if (!row.selectedCandidateId && row.rawData && row.rawData.candidates && row.rawData.candidates.length > 0) {
						this.$set(row, 'selectedCandidateId', row.rawData.candidates[0].id);
					}
				}
			},
			handleExpandChange(row, expandedRows) {
				// 同步展开状态
				if (expandedRows.some(r => r.uuid === row.uuid)) {
					if (this.expandedRowKeys.indexOf(row.uuid) === -1) {
						this.expandedRowKeys.push(row.uuid);
					}
				} else {
					const idx = this.expandedRowKeys.indexOf(row.uuid);
					if (idx > -1) {
						this.expandedRowKeys.splice(idx, 1);
					}
				}
			},
			confirmCandidate(row) {
				if (!row.selectedCandidateId || !row.rawData.candidates) return;
				const candidate = row.rawData.candidates.find(c => c.id === row.selectedCandidateId);
				if (!candidate) return;
				row.matchOrderNo = candidate.orderSn || '';
				row.status = 'valid';
				row.reason = '已关联申请';
				// 收起展开行
				const idx = this.expandedRowKeys.indexOf(row.uuid);
				if (idx > -1) {
					this.expandedRowKeys.splice(idx, 1);
				}
			},
			showDetail(row) {
				this.currentDetail = row;
				this.detailVisible = true;
			},
			submitForm() {
				const validList = this.ocrResults.filter(r => r.status === 'valid');
				if (validList.length === 0) {
					return this.$message.error('暂无可提交的发票记录');
				}
				if (this.processingList.length > 0) {
					return this.$message.warning('还有发票正在解析中，请稍候');
				}
				this.$confirm(`确认提交 ${validList.length} 条可提交的发票记录？`, '提交', {
					confirmButtonText: '确认提交',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					this.doSubmit(validList);
				}).catch(() => {});
			},
			async doSubmit(validList) {
				this.btnLoading = true;
				try {
					const confirmItems = validList.map(r => ({
						fileUri: r.fileUri,
						invoiceRecordId: r.selectedCandidateId || r?.rawData?.id,
					}));
					
					const res = await this.$request({
						url: '/invoice/record/batchUpload',
						method: 'post',
						data: { confirmItems },
					}).catch(() => {
						return { data: { state: '0', msg: '请求错误' } };
					});
					const { state, msg } = res.data;
					if (state == 1) {
						this.$message.success(`提交成功，共 ${validList.length} 条记录`);
						this.$emit('onUpdate');
						this.drawerShow = false;
					} else {
						this.$message.error(msg || '提交失败');
					}
				} finally {
					this.btnLoading = false;
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.tip-alert {
		.tip-tags {
			margin-top: 6px;
			::v-deep .el-tag {
				margin-right: 6px;
				margin-top: 4px;
			}
		}
	}
	.filter-bar {
		margin-top: 16px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	::v-deep .el-upload,
	::v-deep .el-upload-dragger {
		width: 100%;
	}
	.upload-demo {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		padding: 30px 0;
		text-align: center;
		cursor: pointer;
		transition: border-color .2s;
		&:hover {
			border-color: #409EFF;
		}
		.upload-inner {
			.el-icon-upload {
				font-size: 48px;
				color: #c0c4cc;
				margin-bottom: 10px;
			}
			.el-upload__text {
				color: #606266;
				font-size: 14px;
				margin-bottom: 6px;
				em {
					color: #409EFF;
				}
			}
			.upload-tip {
				color: #909399;
				font-size: 12px;
			}
		}
	}
	.tab-bar {
		display: flex;
		border-bottom: 1px solid #e4e7ed;
		margin-bottom: 12px;
		.tab-item {
			padding: 10px 0;
			margin-right: 24px;
			font-size: 14px;
			color: #606266;
			cursor: pointer;
			position: relative;
			b {
				margin-left: 4px;
				font-weight: normal;
				color: #909399;
			}
			&.active {
				color: #409EFF;
				font-weight: 500;
				&::after {
					content: '';
					position: absolute;
					left: 0;
					right: 0;
					bottom: -1px;
					height: 2px;
					background: #409EFF;
				}
				b {
					color: #409EFF;
				}
			}
		}
	}
	.sub-text {
		font-size: 12px;
		color: #909399;
		margin-top: 2px;
		&.color-primary {
			color: #409EFF;
		}
	}
	.reason-text {
		color: #f56c6c;
		font-size: 12px;
		line-height: 1.4;
	}
	.result-table {
		::v-deep .el-table__row {
			&:hover {
				background: #f5f7fa;
			}
		}
		::v-deep .el-table__expanded-cell {
			padding: 0 !important;
		}
		::v-deep .el-table__expanded-cell > div {
			overflow: visible;
		}
	}
	.detail-box {
		.raw-title {
			font-weight: 500;
			margin-bottom: 6px;
		}
		pre {
			background: #f5f7fa;
			padding: 10px;
			border-radius: 4px;
			max-height: 300px;
			overflow: auto;
			font-size: 12px;
			color: #606266;
		}
	}
	.candidate-panel {
		padding: 16px 20px;
		background: #fff;
		overflow: visible;
		.candidate-title {
			font-size: 13px;
			font-weight: 500;
			color: #303133;
			margin-bottom: 12px;
		}
		.candidate-table {
			border: 1px solid #e4e7ed;
			border-radius: 4px;
		}
		.candidate-thead {
			display: flex;
			background: #f5f7fa;
			font-size: 12px;
			color: #909399;
			font-weight: 500;
			border-bottom: 1px solid #e4e7ed;
			span {
				padding: 8px 10px;
				box-sizing: border-box;
				&.col-radio { width: 40px; flex-shrink: 0; text-align: center; }
				&.col-ordersn { width: 180px; flex-shrink: 0; }
				&.col-type { width: 100px; flex-shrink: 0; }
				&.col-goods { flex: 1; min-width: 0; }
				&.col-session { width: 160px; flex-shrink: 0; }
				&.col-time { width: 150px; flex-shrink: 0; }
				&.col-user { width: 120px; flex-shrink: 0; }
			}
		}
		.candidate-tbody {
			.candidate-row {
				display: flex;
				font-size: 12px;
				color: #606266;
				border-bottom: 1px solid #f0f0f0;
				cursor: pointer;
				transition: background .15s;
				&:last-child {
					border-bottom: none;
				}
				&:hover {
					background: #f5f7fa;
				}
				&.active {
					background: #ecf5ff;
					border-left: 3px solid #409EFF;
				}
				span {
					padding: 10px;
					box-sizing: border-box;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					&.col-radio {
						width: 40px;
						flex-shrink: 0;
						display: flex;
						align-items: center;
						justify-content: center;
						::v-deep .el-radio {
							margin-right: 0;
						}
						::v-deep .el-radio__label {
							display: none;
						}
					}
					&.col-ordersn { width: 180px; flex-shrink: 0; color: #303133; font-weight: 500; }
					&.col-type { width: 100px; flex-shrink: 0; }
					&.col-goods { flex: 1; min-width: 0; }
					&.col-session { width: 160px; flex-shrink: 0; color: #909399; }
					&.col-time { width: 150px; flex-shrink: 0; color: #909399; }
					&.col-user { width: 120px; flex-shrink: 0; }
				}
			}
		}
		.candidate-actions {
			margin-top: 12px;
			text-align: left;
		}
	}
</style>
